// extracted by mini-css-extract-plugin
export default {"sliderDiv":"SliderContent_sliderDiv__hlI-G","inputsDiv":"SliderContent_inputsDiv__5LI-e","text":"SliderContent_text__SOQwu"};